import { Table } from 'antd'
import styled from 'styled-components'

import { keyboardFocusedRowCss } from 'hooks/use-table-keyboard-navigation'

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  overflow: hidden;
`

// Only the table body scrolls (pagination + toolbar stay pinned in view) —
// same flex-height recipe ProjectList.tsx uses: `scroll={{ y: 1 }}` on the
// table switches antd into its fixed-header/scrollable-body layout, and
// these overrides let the surrounding flex column (not antd's own
// pixel math) drive the real height.
export const StyledTable = styled(Table)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .ant-spin-nested-loading,
  .ant-spin-nested-loading > .ant-spin-container {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .ant-table {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border: 1px solid #d8d8d8;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-table-container {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
  }

  .ant-table-body {
    flex: 1;
    min-height: 0;
    max-height: none !important;
  }

  .ant-pagination {
    flex-shrink: 0;
    margin-top: 12px;
  }

  .ant-table-thead > tr > th {
    background: #f2f6fd;
    color: #173663;
  }
  .ant-table-tbody > tr > td {
    padding: 8px 16px;
  }

  ${keyboardFocusedRowCss}
` as typeof Table
